export const NAME = "admin";



// WEBPACK FOOTER //
// ./client/modules/Admin/constants.js